import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import React from "react";
import { Layers, Clock, Scale, CheckCircle2 } from "lucide-react";

interface DashboardProps {
  kpis?: {
    lotsToday?: { count: number; centres: number };
    pendingEntry?: { count: number; slaBreachCount: number };
    pendingReconciliation?: { count: number };
    slipsPostedToday?: { count: number };
  };
  isLoading?: boolean;
}

export const Dashboard = ({ kpis, isLoading }: DashboardProps) => {
  const kpiData = [
    {
      title: "Lots Today",
      count: kpis?.lotsToday?.count || 0,
      trendSummary: `Across ${kpis?.lotsToday?.centres || 0} centre${kpis?.lotsToday?.centres === 1 ? "" : "s"}`,
      icon: <Layers className="h-8 w-8 text-slate-500" />,
    },
    {
      title: "Pending Entry",
      count: kpis?.pendingEntry?.count || 0,
      trendSummary: `${kpis?.pendingEntry?.slaBreachCount || 0} SLA breach${kpis?.pendingEntry?.slaBreachCount === 1 ? "" : "es"}`,
      icon: <Clock className="h-8 w-8 text-red-500" />,
    },
    {
      title: "Pending Reconciliation",
      count: kpis?.pendingReconciliation?.count || 0,
      trendSummary: "Waiting for finance sign-off",
      icon: <Scale className="h-8 w-8 text-orange-500" />,
    },
    {
      title: "Slips Posted Today",
      count: kpis?.slipsPostedToday?.count || 0,
      trendSummary: "Auto-posted to consumer ledgers",
      icon: <CheckCircle2 className="h-8 w-8 text-green-500" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {kpiData.map((kpi, index) => (
        <QuickStatsCard
          key={index}
          title={kpi.title}
          count={kpi.count}
          trendSummary={kpi.trendSummary}
          icon={kpi.icon}
        />
      ))}
    </div>
  );
};

export default Dashboard;
